import { MFT_URL, SP_URL } from "@/lib/data";

// External anchor for MyFamilyTree brand mentions.
export function MFT({ children = "MyFamilyTree" }) {
  return (
    <a
      href={MFT_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="link-underline font-medium"
      data-testid="mft-link"
    >
      {children}
    </a>
  );
}

// External anchor for SocialPulse brand mentions.
export function SP({ children = "SocialPulse" }) {
  return (
    <a
      href={SP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="link-underline"
      data-testid="sp-link"
    >
      {children}
    </a>
  );
}
